// assets/dawn-header.js
(function () {
  // Small hover intent delay to avoid flicker
  const OPEN_DELAY = 60;
  const CLOSE_DELAY = 150;

  // Utility: open/close a <details> and sync aria
  function openDetail(detail) {
    if (!detail.hasAttribute('open')) {
      detail.setAttribute('open', '');
    }
    const summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDetail(detail) {
    if (detail.hasAttribute('open')) {
      detail.removeAttribute('open');
    }
    const summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function isTouchPointer(e) {
    // Works for PointerEvents and a dumb fallback
    return (e.pointerType && (e.pointerType === 'touch' || e.pointerType === 'pen')) || 'ontouchstart' in window;
  }
  function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0 // For older IE versions
  );
}

  function initHoverMenus(root) {
    if (!root) return;
    const detailsNodes = root.querySelectorAll('details[data-hover="true"]');

    detailsNodes.forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return;

      // Track timers per dropdown to debounce open/close
      let openT = null;
      let closeT = null;

      function scheduleOpen() {
        clearTimeout(closeT);
        openT = setTimeout(() => openDetail(detail), OPEN_DELAY);
      }
      function scheduleClose() {
        clearTimeout(openT);
        closeT = setTimeout(() => closeDetail(detail), CLOSE_DELAY);
      }

      // ----- Desktop hover behavior
      detail.addEventListener('mouseenter', scheduleOpen);
      detail.addEventListener('mouseleave', scheduleClose);

      // Also close if focus leaves the dropdown (keyboard nav)
      detail.addEventListener('focusout', (e) => {
        if (!detail.contains(e.relatedTarget)) scheduleClose();
      });

      // ----- Summary click behavior
      // On desktop: navigate to data-link without toggling details.
      // On touch: first tap opens, second tap navigates.
      const summaryLink = summary.dataset.link;
      if (summaryLink) {
        summary.addEventListener('click', (e) => {
          // If it's a touch interaction, let the first tap just open
          if (isTouchPointer(e)) {
            if (!detail.hasAttribute('open')) {
              // Allow native toggle to open; don’t navigate yet
              return;
            }
            // Already open -> navigate
            e.preventDefault();
            window.location.href = summaryLink;
            return;
          }

          // Mouse/keyboard: navigate immediately, don’t toggle
          e.preventDefault();
          window.location.href = summaryLink;
        });
      } else {
        // Fallback: if a link exists inside summary, let it handle navigation
        const a = summary.querySelector('a[href]');
        if (a) {
          summary.addEventListener('click', (e) => {
            // Avoid double toggle when clicking the summary background
            if (e.target === summary) {
              e.preventDefault();
              a.click();
            }
          });
        }
      }

      // Ensure initial ARIA state
      const initiallyOpen = detail.hasAttribute('open');
      summary.setAttribute('aria-expanded', initiallyOpen ? 'true' : 'false');
    });
  }

  // Boot on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    // Your menu lives in .site-nav (desktop)
    document.querySelectorAll('.site-nav.site-navigation.small--hide').forEach(initHoverMenus);
  });

  // Shopify Theme Editor re-render hooks
  document.addEventListener('shopify:section:load', (evt) => {
    const section = evt.target;
    if (!section) return;
    // Re-init any new .site-nav that was just rendered
    section.querySelectorAll?.('.site-nav.site-navigation.small--hide').forEach(initHoverMenus);
  });
})();
